<template>
    <v-datepicker
            range

            :editable="false"
            :clearable="false"
            :popupStyle="{left:0}"
            width="100%"
            @input="updateValue"
            :value="value"
            :lang="lang"
            :placeholder="placeholder"
            :first-day-of-week="firstDayOfWeek"
            :format="formatComputed">
        <template slot="header">{{header}}</template>
        <template slot="calendar-icon"><i class="fa fa-calendar" aria-hidden="true"></i></template>
        <template slot="footer">{{footer}}</template>
    </v-datepicker>
</template>

<script>
    import DatePicker from 'vue2-datepicker'
    import moment from 'moment'

    export default {
        name: "DateRangePicker",
        props: {
           placeholder:{
            type:String
           },
            value: {
                default: [null, null]
            },
            header: {
                type: String,
                default: null
            },
            footer: {
                type: String,
                default: null
            },
            format: {
                type: String,
                default: null
            },
            responseFormat: {
                type: String,
                default: 'YYYY-MM-DD'
            }
        },
        components: {
            'v-datepicker': DatePicker
        },
        data() {
            return {
                lang: {
                    days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
                    months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
                    pickers: ['next 7 days', 'next 30 days', 'previous 7 days', 'previous 30 days'],
                    placeholder: {
                        date: 'Select Date',
                        dateRange: 'Select Date Range'
                    }
                },
                // custom range shortcuts
                shortcuts: [
                    {
                        text: 'Today',
                        onClick: () => {
                            this.time3 = [new Date(), new Date()]
                        }
                    }
                ],

            }
        },
        methods: {
            updateValue(val) {
                this.$emit('rangeChange', this.reformatUpdateDate(val))
            },
            reformatUpdateDate(value) {
                const momentDate = new moment(value[0])
                const momentDate2 = new moment(value[1])
                return {
                    start: momentDate.format(this.responseFormat),
                    end: momentDate2.format(this.responseFormat),
                }


            }
        },
        computed: {
            firstDayOfWeek() {
                return Number(this.$t('DATE.FIRST_DAY_OF_WEEK'))
            },
            formatComputed() {
                return !this.format ? this.$t('DATE.DATE_FORMAT') : this.format
            }
        }
    }
</script>

<style scoped>

</style>
